import React, { ReactElement } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IProductDataGM, useGarantieMaxActions } from '../GarantieMax';
import { ILeadData } from 'Services/widgets/interfaces';
import { useLocation } from 'react-router-dom';
import { INavItem, mobMenuListGM, parseHashUrl } from '../../bf-hooks';

export interface INavlDataProps {
  defaultActiveKey: string;
  lead: ILeadData;
  productData: IProductDataGM;
}

export const NavMobileSelector: React.FC<INavlDataProps> = ( {
  defaultActiveKey, lead,
} ) => {
  const { t } = useTranslation( [ 'widgets', 'base' ] );
  const location = useLocation();
  const urlHash: string = location.hash.substring( 1 );
  const hashParams = parseHashUrl( urlHash );
  const actions = useGarantieMaxActions();
  const itemList = mobMenuListGM();

  const getCurrentStep = React.useCallback( (): INavItem => {
    let currentHash = defaultActiveKey;

    if ( hashParams && hashParams[0] ) {
      currentHash = hashParams[0].value;
    }

    const currentItem = itemList.find( ( c ) => c.hashStep === currentHash )!;
    return currentItem;
  }, [ defaultActiveKey, hashParams, itemList ] );

  const currentStep = getCurrentStep();

  const onClickItem = React.useCallback( ( stepName: string ) => {
    actions.goToStep( stepName, false );
  }, [ actions ] );

  const isActiveItem = React.useCallback( ( nameHash: string ) => {
    const params = hashParams.filter( ( param ) => param.value === nameHash );

    if ( params.length > 0 ) {
      return true;
    }
    return false;
  }, [ hashParams ] );

  const dropdownItems = React.useMemo<ReactElement[]>( () => {
    return itemList.map( ( item ): ReactElement => {
      let isDisabled: boolean = false;
      const isActive: boolean = isActiveItem( item.hashStep );
      if ( lead && lead[item.dataKey!] === null ) {
        isDisabled = true;
      }

      return (
        <Dropdown.Item
          id={ `bf-menu-item-${item.numberStep}` }
          key={ item.numberStep }
          onClick={ () => { onClickItem( item.hashStep ); } }
          className="d-flex justify-content-start align-items-center"
          disabled={ !isActive && isDisabled }
          active={ isActive }
        >
          <span className="bf-item-icon">{ t( item.numberStep ) }</span>
          <span className="bf-item-name">{ t( item.nameStep ) }</span>
        </Dropdown.Item>
      );
    } );
  }, [ isActiveItem, itemList, lead, onClickItem, t ] );

  return (
    <Dropdown className="drp-nav-selector">
      <Dropdown.Toggle variant={ 'link' } id="mobile-nav">
        <div className="d-flex justify-content-between">
          <div className="bf-current-item text-left">
            <div className={ `bf-progress bf-color-bar bf-step-${t ( currentStep.numberStep )}` }>
              <span className="bf-progress-left">
                <span className="bf-progress-bar"></span>
              </span>
              <span className="bf-progress-right">
                <span className="bf-progress-bar"></span>
              </span>
              <div className="bf-progress-value">{ t ( currentStep.numberStep ) }/{ itemList.length }</div>
            </div>
            <span className="bf-current-name">{ t ( currentStep.nameStep ) }</span>
          </div>
          <div>
            <span className="bf-icon-menu">
              <i className="bg-dropdown-indicator"></i>
            </span>
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="pb-3" id="bf-mobile-menu">
        { dropdownItems }
      </Dropdown.Menu>
    </Dropdown>
  );
};
